import Grid from "@mui/material/Grid";
import GCAutocompleteCheckbox from "../../../Component/Common/ReuseableComponent/GCAutocompleteCheckbox";
import {
  CmpTypographyField,
  CmpSelectField,
  CmpDatePickerField,
  CmpRadioButton,
} from "../../../Component/Common/ToolBox/ToolBox.js";
import GCBrandSearch from "../../../Component/Common/ReuseableComponent/GCBrandSearch.jsx";

export default function WmsHead({
  fLocation_MultiSelect,
  sLocationData,

  fMainGroup_MultiSelect,
  sMainGroupData,
  fSubGroup_MultiSelect,
  sSubGroupData,

  fCategory_MultiSelect,
  sCategoryData,

  fBrand_MultiSelect,
  sBrandData,

  fBrandCategory_MultiSelect,
  sBrandCategoryData,

  fMainSupplier_MultiSelect,
  sMainSupplierData,

  //multiselect
  sWebStockReportData,

  HeadObject,
  setHeadObject,
  fLocation,
  fMainGroup,
  fSubGroup,
  fCategory,
  fMainSupplier,
  fBrand,
  fFromDate,
  fToDate,
  fBoundType,
  fReportType,
  sWebPartyReportArr,
}) {
  return (
    <form id="DcCostCompareHistoryReportHead">
      <Grid
        container
        rowSpacing={{ xs: 0, sm: 0, md: 1 }}
        columnSpacing={{ xs: 0, sm: 0, md: 0 }}
        columns={{ xs: 12, sm: 12, md: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          className="d-flex align-items-center"
        >
          <CmpTypographyField
            xcomponent={"h1"}
            xText={"WMS Tracker Report"}
            xfontSize="20px"
            xtextDecoration="underline"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Date"} />
            </Grid>
            <Grid item xs={3} sm={4.5} md={4.5} lg={4.5}>
              <CmpDatePickerField
                xValue={HeadObject.sFromDate}
                xOnChange={fFromDate}
                xName={"sFromDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
            <Grid item xs={3} sm={4.5} md={4.5} lg={4.5}>
              <CmpDatePickerField
                xValue={HeadObject.sToDate}
                xOnChange={fToDate}
                xName={"sToDate"}
                xError={false}
                xErrorMessage={""}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Location"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"01"}
                xLabelText="sLocation"
                xValue={HeadObject.sLocation}
                xOnChange={fLocation}
                xName={"sLocation"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={true}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"02"}
                options={sLocationData}
                xDisabled={
                  HeadObject?.sLocation?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sLocationArr}
                setValue={fLocation_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Main Group"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"03"}
                xLabelText="sMainGroup"
                xValue={HeadObject.sMainGroup}
                xOnChange={fMainGroup}
                xName={"sMainGroup"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"04"}
                options={sMainGroupData}
                xDisabled={
                  HeadObject?.sMainGroup?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sMainGroupArr}
                setValue={fMainGroup_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Sub Group"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"05"}
                xLabelText="sSubGroup"
                xValue={HeadObject.sSubGroup}
                xOnChange={fSubGroup}
                xName={"sSubGroup"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"06"}
                options={sSubGroupData}
                xDisabled={
                  HeadObject?.sSubGroup?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sSubGroupArr}
                setValue={fSubGroup_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Category"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"07"}
                xLabelText="sCategory"
                xValue={HeadObject.sCategory}
                xOnChange={fCategory}
                xName={"sCategory"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"08"}
                options={sCategoryData}
                xDisabled={
                  HeadObject?.sCategory?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sCategoryArr}
                setValue={fCategory_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Brand"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"11"}
                xLabelText="sBrand"
                xValue={HeadObject.sBrand}
                xOnChange={fBrand}
                xName={"sBrand"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            {/* <Grid item xs={6} sm={6} md={4} lg={4}>
              <GCAutocompleteCheckbox
                xtabIndex={"12"}
                options={sBrandData}
                xDisabled={
                  HeadObject?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sBrandArr}
                setValue={fBrand_MultiSelect}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={4} lg={4}>
              <GCAutocompleteCheckbox
                xtabIndex={"13"}
                options={sBrandCategoryData}
                xDisabled={
                  HeadObject?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                xValue={HeadObject.sBrandCategoryArr}
                setValue={fBrandCategory_MultiSelect}
              />
            </Grid> */}
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCBrandSearch
                xValue={HeadObject?.sBrandSearchValue} //main input value
                xOnChange={(e) => {
                  setHeadObject((obj) => ({
                    ...obj,
                    sBrandSearchValue: e.target.value,
                  })); //main input onchange
                }}
                xReadOnly={
                  HeadObject?.sBrand?.toUpperCase() === "ALL" ? true : false
                }
                basketValue={HeadObject?.sBrandArr} //Search basket array
                xListValue={HeadObject?.sBrandArr
                  .map((x) => x.Name1)
                  .join(", ")} // 2nd main input
                onApply={(selectedObjects) => {
                  setHeadObject((obj) => ({
                    ...obj,
                    sBrandArr: selectedObjects,
                  }));
                  // setBrandBasket(selectedObjects) //array of object
                }} // <- handle selected names
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 1 }}
            columnSpacing={{ xs: 0, sm: 0, md: 1 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Party"} />
            </Grid>
            <Grid item xs={3} sm={3} md={1} lg={1}>
              <CmpSelectField
                xtabIndex={"09"}
                xLabelText="sMainSupplier"
                xValue={HeadObject.sMainSupplier}
                xOnChange={fMainSupplier}
                xName={"sMainSupplier"}
                xData={sWebStockReportData}
                xValueMember={""}
                xDispalyMember={""}
                xError={false}
                xErrorMessage={""}
                xDisable={false}
              />
            </Grid>
            <Grid item xs={6} sm={6} md={8} lg={8}>
              <GCAutocompleteCheckbox
                xtabIndex={"10"}
                options={sMainSupplierData}
                xDisabled={
                  HeadObject?.sMainSupplier?.toUpperCase() === "ALL"
                    ? true
                    : false
                }
                xValue={HeadObject.sMainSupplierArr}
                setValue={fMainSupplier_MultiSelect}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Inbound Type"} />
            </Grid>
            {sWebPartyReportArr?.map((type, index) => (
              <Grid item xs={2.2} sm={2.2} md={2} lg={2} key={index}>
                <CmpRadioButton
                  value={type.UId}
                  label={type.Name1}
                  checked={HeadObject.sboundType === type.UId}
                  onChange={fBoundType}
                />
              </Grid>
            ))}
          </Grid>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Grid
            container
            rowSpacing={{ xs: 0, sm: 0, md: 0 }}
            columnSpacing={{ xs: 0, sm: 0, md: 0 }}
            columns={{ xs: 12, sm: 12, md: 12 }}
            alignItems="center"
          >
            <Grid item xs={3} sm={3} md={1.3} lg={1.3}>
              <CmpTypographyField xcomponent={"span"} xText={"Report Type"} />
            </Grid>

            <Grid item xs={4.5} sm={3} md={2} lg={2}>
              <CmpRadioButton
                value={"INBOUND"}
                label={"Inbound Tracker"}
                checked={HeadObject.sReportType === "INBOUND"}
                onChange={fReportType}
              />
            </Grid>
            <Grid item xs={4.5} sm={3} md={2.4} lg={2.4}>
              <CmpRadioButton
                value={"PUTAWAY"}
                label={"Put-Away Tracker"}
                checked={HeadObject.sReportType === "PUTAWAY"}
                onChange={fReportType}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
}
